// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-modal-button[data-v-622242d9] {
  position: absolute;
  left: 8px;
  top: 8px;
  padding: 2px !important;
}
.button-with-icon-left[data-v-622242d9] {
  position: relative;
  right: 6px;
}
.button-with-icon-right[data-v-622242d9] {
  position: relative;
  left: 6px;
}
[data-v-622242d9] .i-dropdown-content {
  box-shadow: -2px 3px 6px grey;
}
.list-item[data-v-622242d9]:hover {
  cursor: pointer;
  background-color: var(--622242d9-\\\$getStyles\\.hoverBackgroundColor);
}
.list-item.selected-item[data-v-622242d9] {
  background-color: var(--622242d9-\\\$getStyles\\.selectedBackgroundColor);
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/dynamic-components/builder-engine/inspector/tools/FontFamilyPickerV2.vue","webpack://./FontFamilyPickerV2.vue"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;ACDF;ADIA;EACE,kBAAA;EACA,UAAA;ACDF;ADIA;EACE,kBAAA;EACA,SAAA;ACDF;ADIA;EACE,6BAAA;ACDF;ADME;EACE,eAAA;EACA,mEAAA;ACHJ;ADME;EACE,sEAAA;ACJJ","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.close-modal-button {\n  position: absolute;\n  left: 8px;\n  top: 8px;\n  padding: 2px !important;\n}\n\n.button-with-icon-left {\n  position: relative;\n  right: 6px;\n}\n\n.button-with-icon-right {\n  position: relative;\n  left: 6px;\n}\n\n:deep(.i-dropdown-content) {\n  box-shadow: -2px 3px 6px grey;\n}\n\n.list-item {\n\n  &:hover {\n    cursor: pointer;\n    background-color: v-bind('$getStyles.hoverBackgroundColor');\n  }\n\n  &.selected-item {\n    background-color: v-bind('$getStyles.selectedBackgroundColor');\n  }\n}\n",".close-modal-button {\n  position: absolute;\n  left: 8px;\n  top: 8px;\n  padding: 2px !important;\n}\n\n.button-with-icon-left {\n  position: relative;\n  right: 6px;\n}\n\n.button-with-icon-right {\n  position: relative;\n  left: 6px;\n}\n\n:deep(.i-dropdown-content) {\n  box-shadow: -2px 3px 6px grey;\n}\n\n.list-item:hover {\n  cursor: pointer;\n  background-color: v-bind(\"$getStyles.hoverBackgroundColor\");\n}\n.list-item.selected-item {\n  background-color: v-bind(\"$getStyles.selectedBackgroundColor\");\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
